import { request } from '../request';

const massageApi = {
  /**
   * 获取按摩任务信息
   */
  getMassageTaskInfo(orderId: string) {
    return request<GetMassageTaskInfoResponse[]>({
      path: '/pad/massage/v1/get/massage/task/info',
      query: { orderId },
    });
  },
  /**
   * 开始按摩
   */
  startRoboticTask(params: StartRoboticTaskParams) {
    return request({
      method: 'POST',
      path: '/pad/massage/v1/start/robotic/task',
      data: params,
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 自定义画线保存设置并开始按摩
   */
  startCustomRouteTask(params: StartCustomRouteTaskParams) {
    return request({
      method: 'POST',
      path: '/pad/massage/v1/start/customRoute/massage',
      data: params,
    });
  },
  /**
   * 获取用户设置
   */
  getMassageUserSettings(orderId: string) {
    return request<GetMassageUserSettingsResponse>({
      path: '/pad/massage/v1/get/massage/user/settings',
      query: { orderId },
    });
  },
  /**
   * 保存3d截图
   */
  save3DScreenshot(params: Save3DScreenshotParams) {
    return request<never>({
      method: 'POST',
      path: '/pad/massage/v1/save/3d/screenshot',
      query: params,
      config: {
        ignoreErrorMessage: true,
      },
    });
  },
  /**
   * 结束按摩
   */
  quitMassage(params: QuitMassageParams) {
    return request<{
      waitTaskFinishedEvent: true;
      shockwaveProbeCount: number;
      probeMaxUseCount?: number;
      orderMaxUseCount?: number;
    }>({
      method: 'POST',
      path: '/pad/massage/v1/quit',
      query: params,
    });
  },
  /**
   * 结束按摩
   */
  quitMassageFromEvent(params: QuitMassageFromEventParams) {
    return request<{ probeMaxUseCount?: number; orderMaxUseCount?: number }>({
      method: 'POST',
      path: '/pad/massage/v1/silent/quit',
      query: params,
    });
  },
  /**
   * 获取遥控器面板参数
   */
  getMassageControlPannel(orderId: string) {
    return request<GetMassageControlPannelResponse>({
      path: '/pad/massage/v1/get/massage/control/pannel',
      query: { orderId },
    });
  },
  /**
   * 获取遥控器面板参数
   */
  getMassageSettingsOptions(orderId: string) {
    return request<GetMassageSettingsOptionsResponse>({
      path: '/pad/massage/v1/get/massage/settings/options',
      query: { orderId },
    });
  },
};

export default massageApi;
